import classNames from "classnames";
import { useEffect, useState } from "react";

import SvgIcon from "../SvgIcon";

import styles from "./index.module.scss";

interface ICheckboxProps {
  className?: string;
  label?: string | React.ReactNode;
  value: boolean;
  valueKey?: string;
  onChange?: ({
    value,
    valueKey,
  }: {
    value: boolean;
    valueKey: string;
  }) => void;
}

function Checkbox({
  className = "",
  label,
  value,
  valueKey,
  onChange,
}: ICheckboxProps) {
  const [internalValue, setInternalValue] = useState(!!value);

  const handleChange = (value: boolean) => () => {
    if (onChange) {
      onChange({ value, valueKey: valueKey ?? "" });
    }

    if (!onChange) {
      setInternalValue(value);
    }
  };

  useEffect(() => {
    setInternalValue(!!value);
  }, [value]);

  return (
    <div
      className={classNames(styles.container, className)}
      onClick={handleChange(!internalValue)}>
      <SvgIcon
        type={internalValue ? "FiCheckSquare" : "FiSquare"}
        className={styles.icon}
      />

      {label && <p className={styles.label}>{label}</p>}
    </div>
  );
}

export default Checkbox;
